import { useMemo } from 'react';
import { useLaunchParams, useSignal, viewport, miniApp } from '@tma.js/sdk-react';

/**
 * One-stop hook for the most common Telegram launch info needed by UI:
 * the parsed launch params, the current platform, and a flag for whether
 * we're inside a real Telegram client (vs the dev mock).
 */
export function useTelegram() {
  const launchParams = useLaunchParams();
  const isDark = useSignal(miniApp.isDark);
  const viewportHeight = useSignal(viewport.height);

  return useMemo(
    () => ({
      launchParams,
      platform: launchParams.tgWebAppPlatform,
      user: launchParams.tgWebAppData?.user,
      isDark,
      viewportHeight,
    }),
    [launchParams, isDark, viewportHeight],
  );
}
